import { render, staticRenderFns } from "./Create-Payroll.vue?vue&type=template&id=09fc2744"
import script from "./Create-Payroll.vue?vue&type=script&lang=js"
export * from "./Create-Payroll.vue?vue&type=script&lang=js"
import style0 from "./Create-Payroll.vue?vue&type=style&index=0&id=09fc2744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports